import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { noop } from 'lodash';
import { getClient } from '../../crossLinks/ApolloContextProvider';
import { API_URL } from '../../../common/consts';

interface EntityApolloContextProviderProps {
    auth: any;
    children: React.ReactNode;
}

export const EntityApolloContextProvider: React.FC<EntityApolloContextProviderProps> = (props) => {
    const entityUri = API_URL + '/v2/entity-query/graphql';
    return (
        <ApolloProvider client={getClient(props.auth, entityUri, noop)}>
            {props.children}
        </ApolloProvider>
    );
};

export default EntityApolloContextProvider;
